import { render, staticRenderFns } from "./AddNewAppAdUnits.vue?vue&type=template&id=cefced40&scoped=true&"
import script from "./AddNewAppAdUnits.vue?vue&type=script&lang=js&"
export * from "./AddNewAppAdUnits.vue?vue&type=script&lang=js&"
import style0 from "./AddNewAppAdUnits.vue?vue&type=style&index=0&id=cefced40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cefced40",
  null
  
)

export default component.exports